import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Menu, Dropdown } from 'client/semantic-imports'
import { AccountStatus } from 'cat-shared/utils'
import { AppHeader } from 'client/ui-building-blocks'
import { getLocalAuthUser } from 'client/services'

import TopBarAccountDropdown from './top-bar-account-dropdown'

import styles from './top-bar.module.scss'
import './top-bar.scss'

type Props = {
  accountStatus: AccountStatus
  getOnClickHandler: (path: string) => () => void
}

const TopBarMobile = ({ accountStatus, getOnClickHandler }: Props) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const localAuthUser = getLocalAuthUser()

  return (
    <>
      <Menu.Menu>
        <Dropdown
          simple
          item
          aria-label="places"
          trigger={
            <AppHeader
              text={t('rootPage.topBar.browse.label')}
              color="light"
              size="small"
            />
          }
        >
          <Dropdown.Menu className={styles.menu}>
            <Dropdown.Item
              className={styles.item}
              onClick={getOnClickHandler('/home')}
              active={pathname === '/home'}
            >
              <AppHeader
                text={t('rootPage.topBar.browse.items.home')}
                color="light"
                size="small"
              />
            </Dropdown.Item>
            <Dropdown.Item
              className={styles.item}
              onClick={getOnClickHandler('/random')}
              active={pathname === '/random'}
            >
              <AppHeader
                text={t('rootPage.topBar.browse.items.random')}
                color="light"
                size="small"
              />
            </Dropdown.Item>
            <Dropdown.Item
              onClick={getOnClickHandler('/browse')}
              active={pathname === '/browse'}
            >
              <AppHeader
                text={t('rootPage.topBar.browse.items.all')}
                color="light"
                size="small"
              />
            </Dropdown.Item>
            <Dropdown.Item
              onClick={getOnClickHandler('/create')}
              active={pathname === '/create'}
            >
              <AppHeader text={t('rootPage.topBar.creator')} color="light" size="small" />
            </Dropdown.Item>
            <Dropdown.Item
              onClick={getOnClickHandler('/best')}
              active={pathname === '/best'}
            >
              <AppHeader
                text={t('rootPage.topBar.bestOfTheBest')}
                color="light"
                size="small"
              />
            </Dropdown.Item>
            {localAuthUser.isAdmin === 'true' ? (
              <Dropdown.Item
                onClick={getOnClickHandler('/data')}
                active={pathname === '/data'}
              >
                <AppHeader
                  text={t('rootPage.topBar.dataManager')}
                  color="light"
                  size="small"
                />
              </Dropdown.Item>
            ) : null}
            {process.env.NODE_ENV === 'development' ? (
              <Dropdown.Item
                onClick={getOnClickHandler('/ui')}
                active={pathname === '/ui'}
              >
                <AppHeader text={t('rootPage.topBar.ui')} color="light" size="small" />
              </Dropdown.Item>
            ) : null}
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
      <TopBarAccountDropdown
        accountStatus={accountStatus}
        getOnClickHandler={getOnClickHandler}
      />
    </>
  )
}

export default TopBarMobile
